import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';

const ConsultaLiquidaciones = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  // Estados principales
  const [respuestaApi, setRespuestaApi] = useState([]);
  const [respuestaApiOriginal, setRespuestaApiOriginal] = useState([]); // Para guardar los datos sin filtrar
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [fechaConsulta, setFechaConsulta] = useState(getCurrentDate());
  
  // Estados para filtros
  const [filtroRuta, setFiltroRuta] = useState('');
  const [filtroDocumento, setFiltroDocumento] = useState('');
  const [filtroCliente, setFiltroCliente] = useState('');
  const [filtroCondicionPago, setFiltroCondicionPago] = useState('');
  
  // Estados para el seguimiento
  const [opcionesSeguimiento, setOpcionesSeguimiento] = useState([]);
  const [cargandoSeguimiento, setCargandoSeguimiento] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [liquidacionSeleccionada, setLiquidacionSeleccionada] = useState(null);
  const [seguimientoSeleccionado, setSeguimientoSeleccionado] = useState('');
  const [responsableSeleccionado, setResponsableSeleccionado] = useState(''); 
  const [arearesponsableSeleccionado, setareaResponsableSeleccionado] = useState('');
  const [opcionesArea, setOpcionesArea] = useState([]);


  const [showComentarioModal, setShowComentarioModal] = useState(false);
  const [comentario, setComentario] = useState('');
  const [liquidacionComentario, setLiquidacionComentario] = useState(null);

  const [refresh, setRefresh] = useState(false);
    const { user } = useSelector(state => state.auth);
  // Datos de ejemplo para responsables

  const responsables = [
    { id: 12, nombre: 'Juan Pérez' },
    { id: 15, nombre: 'María García' },
    { id: 18, nombre: 'Carlos López' }
  ];

  const datosParaEnviar = {
    Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
    Ambiente: 'DESA',
    Dispositivo: {
      Marca: 'SAMSUNG',
      Modelo: 'S22002B',
      Version: 'Android 18.125',
      McAdress: null,
      PowerStatus: '84%',
      WifiStatus: 'Conected to iphone de Mauricio',
      GPSStatus: 'ON',
      GPS: '321|-485|321'
    },
    Usr: {
      Codigo: '',
      UserNickName: 'pierril'
    },
    DatosMetodo: {
      NombreMetodo: 'ObtenerListaLiquidacionesWeb',
      Datos_Recibidos: '',
      datos_Generados: ''
    }
  };

  // Función para aplicar los filtros
  const aplicarFiltros = () => {
    let datosFiltrados = [...respuestaApiOriginal];
    
    if (filtroRuta) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Ruta?.toString().toLowerCase().includes(filtroRuta.toLowerCase())
      );
    }
    
    if (filtroDocumento) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Num_Documento?.toString().toLowerCase().includes(filtroDocumento.toLowerCase())
      );
    }
    
    if (filtroCliente) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Nombre_CLiente?.toLowerCase().includes(filtroCliente.toLowerCase()) ||
        item.Codigo_Cliente?.toString().toLowerCase().includes(filtroCliente.toLowerCase())
      );
    }
    
    if (filtroCondicionPago) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Condicion_Pago?.toLowerCase().includes(filtroCondicionPago.toLowerCase())
      );
    }
    
    setRespuestaApi(datosFiltrados);
  };

  // Función para limpiar los filtros
  const limpiarFiltros = () => {
    setFiltroRuta('');
    setFiltroDocumento('');
    setFiltroCliente('');
    setFiltroCondicionPago('');
    setRespuestaApi(respuestaApiOriginal);
  };

  // Función para obtener las opciones de seguimiento
  const fetchOpcionesSeguimiento = async () => {
    try {
      setCargandoSeguimiento(true);
      
      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        Usr: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        DatosMetodo: {
          NombreMetodo: 'ObtenerListaCatalogosSeguimientoLiqui',
          Datos_Recibidos: ''
        }
      };

      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.datos_Generados) {
        throw new Error('No se encontraron datos generados');
      }
      
      const datosGenerados = JSON.parse(data.datos_Generados); 
      console.log(datosGenerados)
      const opcionesFiltradas = (datosGenerados.CATALOGOS || []).filter(
        opcion => opcion.TipoLista === 'ESTADO' && opcion.est_codigo !== 15 && opcion.est_codigo !== 6
      );
      setOpcionesSeguimiento(opcionesFiltradas);
      const opcionesFiltradas2 = (datosGenerados.CATALOGOS || []).filter(
        opcion => opcion.TipoLista === 'DEPARTAMENTOS'
      ); 
      console.log(opcionesFiltradas2)
      setOpcionesArea(opcionesFiltradas2)

    


    } catch (err) {
      console.error('Error al obtener opciones de seguimiento:', err);
    } finally {
      setCargandoSeguimiento(false);
    }
  };

  const consultarApi = async () => {
    setCargando(true);
    setError(null);
    
    try {
      const requestData = {
        ...datosParaEnviar,
        DatosMetodo: {
          ...datosParaEnviar.DatosMetodo,
          Datos_Recibidos: JSON.stringify({ Fecha: fechaConsulta, IdUsuario: user.id_usuario  })
        }
      };
      
      console.log(requestData)
      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const respuesta = await fetch(url);
      
      if (!respuesta.ok) {
        throw new Error(`Error HTTP: ${respuesta.status}`);
      }
  
      const datos = await respuesta.json();
      console.log(datos)
      if (!datos.datos_Generados) {
        throw new Error('No se encontraron datos generados en la respuesta');
      }
      
      const datosGenerados = JSON.parse(datos.datos_Generados);
      const liquidaciones = datosGenerados.LIQUIDACION || [];
      
      const liquidacionesSinSeguimiento = Array.isArray(liquidaciones) 
        ? liquidaciones.filter(item => item.sp_codigo === undefined || item.sp_codigo === null)
        : (!liquidaciones.sp_codigo ? [liquidaciones] : []);
      console.log(liquidaciones)
      setRespuestaApi(liquidacionesSinSeguimiento);
      setRespuestaApiOriginal(liquidacionesSinSeguimiento); // Guardar datos originales
    } catch (err) {
      setError(err.message);
      console.error('Error al consultar la API:', err);
    } finally {
      setCargando(false);
    }
  };

  // Función para manejar el clic en el botón de seguimiento
  const handleSeguimientoClick = (liquidacion) => {
    setLiquidacionSeleccionada(liquidacion);
    setShowModal(true);
  };

  const handleCheckClick = (liquidacion) => {
    const seguimientoData = {
      CodCliente: liquidacion.Codigo_Cliente,
      DocNumOINV: liquidacion.Num_Documento,
      NumAtCard: liquidacion.Num_Ref,
      Estado: 15, // Estado fijo 15 para check
      Responsable: 1, // Puedes ajustar el responsable por defecto o pedirlo
      Comentario: '' // Sin comentario
    };
    console.log(seguimientoData)
    guardarSeguimiento(seguimientoData);
  };
  
  const handleComentarioClick = (liquidacion) => {
    setLiquidacionComentario(liquidacion);
    setShowComentarioModal(true);
  };
  
  const confirmarComentario = () => {
    if (!comentario) {
      alert('Por favor ingrese un comentario');
      return;
    }
  
    const seguimientoData = {
      CodCliente: liquidacionComentario.Codigo_Cliente,
      DocNumOINV: liquidacionComentario.Num_Documento,
      NumAtCard: liquidacionComentario.Num_Ref,
      Estado: 15, // Estado fijo 15 para comentario
      Responsable: 1, // Puedes ajustar el responsable por defecto o pedirlo
      Comentario: comentario
    };
    console.log(seguimientoData)
    guardarSeguimiento(seguimientoData);
    setShowComentarioModal(false);
    setComentario('');
  };  
  // Función para confirmar el seguimiento
  const confirmarSeguimiento = () => {
    if (!seguimientoSeleccionado) {
      alert('Por favor seleccione un tipo de seguimiento y un responsable');
      return;
    }

    const seguimientoData = {
      CodCliente: liquidacionSeleccionada.Codigo_Cliente,
      DocNumOINV: liquidacionSeleccionada.Num_Documento,
      NumAtCard: liquidacionSeleccionada.Num_Ref,
      Estado: parseInt(seguimientoSeleccionado),
      Responsable: parseInt(responsableSeleccionado),
      AreaResponsable: parseInt(arearesponsableSeleccionado),

    };
    
    guardarSeguimiento(seguimientoData);
    setShowModal(false);
  };


  const guardarSeguimiento = async (seguimientoData) => {
    try {
      setCargando(true);
      
      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        Metodo: {
          NombreMetodo: 'CrearSeguimiento',
          Datos_Recibidos: JSON.stringify(seguimientoData),
          datos_Generados: ''
        }
      };
  
      const url = 'https://appcorp.parma.com.gt/API/ReceptorDatos';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });
  
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      if (!data.datos_Generados) {
        throw new Error('La API no devolvió datos generados');
      }
  
      alert('Seguimiento registrado exitosamente');
      
      // Espera breve para asegurar que el servidor procesó el cambio
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Realiza una nueva consulta para obtener los datos actualizados
      aplicarFiltros();
      await consultarApi();
     // await aplicarFiltros();
      return data;
  
    } catch (err) {
      console.error('Error al guardar seguimiento:', err);
      alert(`Error al guardar seguimiento: ${err.message}`);
      throw err;
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { 
    console.log(user.id_usuario)
    consultarApi();
    fetchOpcionesSeguimiento();
  }, []);

  useEffect(() => {
    if (respuestaApiOriginal.length > 0) {
      aplicarFiltros();
    }
  }, [filtroRuta, filtroDocumento, filtroCliente, filtroCondicionPago, respuestaApiOriginal]);

  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return '';
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-GT');
  };

  const handleFechaChange = (e) => {
    setFechaConsulta(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    consultarApi();
  };

  return (
    <div className="container mt-4">
      {/* Modal de confirmación de seguimiento */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Registrar Seguimiento</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Tipo de Seguimiento:</label>
                  <select 
                    className="form-select"
                    value={seguimientoSeleccionado}
                    onChange={(e) => setSeguimientoSeleccionado(e.target.value)}
                  >
                    <option value="">Seleccione una opción</option>
                    {opcionesSeguimiento.map((opcion) => (
                      <option key={opcion.id} value={opcion.est_codigo}>
                        {opcion.est_nombre}
                      </option>
                    ))}
                  </select>
                </div>
               {/*<div className="mb-3">
                  <label className="form-label">Responsable:</label>
                  <select 
                    className="form-select"
                    value={responsableSeleccionado}
                    onChange={(e) => setResponsableSeleccionado(e.target.value)}
                  >
                    <option value="">Seleccione un responsable</option>
                    {responsables.map((resp) => (
                      <option key={resp.id} value={resp.id}>
                        {resp.nombre}
                      </option>
                    ))}
                  </select>
                </div> */} 
                <div className="mb-3">
                  <label className="form-label"> Area Responsable:</label>
                  <select 
                    className="form-select"
                    value={arearesponsableSeleccionado}
                    onChange={(e) => setareaResponsableSeleccionado(e.target.value)}
                  >
                    <option value="">Seleccione un responsable</option>
                    {opcionesArea.map((resp) => (
                      <option key={resp.id} value={resp.est_codigo}>
                        {resp.est_nombre}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="alert alert-warning">
                  ¿Está seguro que desea registrar este seguimiento?
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setShowModal(false)}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={confirmarSeguimiento}
                >
                  Confirmar Seguimiento
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="card border-0 shadow-none">
        <div className="card-header bg-transparent border-0 px-0 pt-0">
          <h1 className="text-center mb-4">Consulta de Liquidador</h1>
        </div>
        
        <div className="card-body px-0">
          <form onSubmit={handleSubmit} className="mb-4">
            <div className="row g-3 align-items-center">
              <div className="col-md-4">
                <label htmlFor="fechaConsulta" className="form-label">Fecha de Factura:</label>
                <input 
                  type="date" 
                  id="fechaConsulta" 
                  className="form-control"
                  value={fechaConsulta}
                  onChange={handleFechaChange}
                />
              </div>
              <div className="col-md-4 d-flex align-items-end">
                <button 
                  type="submit" 
                  disabled={cargando}
                  className="btn btn-success"
                >
                  {cargando ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Consultando...
                    </>
                  ) : 'Consultar'}
                </button>
              </div>
            </div>
          </form>
          
          {/* Sección de Filtros */}
          <div className="card mb-4">
            <div className="card-header bg-light">
              <h5 className="mb-0">Filtros</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-3">
                  <label htmlFor="filtroRuta" className="form-label">Ruta</label>
                  <input
                    type="text"
                    id="filtroRuta"
                    className="form-control"
                    placeholder="Filtrar por ruta"
                    value={filtroRuta}
                    onChange={(e) => setFiltroRuta(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="filtroDocumento" className="form-label">Documento</label>
                  <input
                    type="text"
                    id="filtroDocumento"
                    className="form-control"
                    placeholder="Filtrar por documento"
                    value={filtroDocumento}
                    onChange={(e) => setFiltroDocumento(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="filtroCliente" className="form-label">Cliente</label>
                  <input
                    type="text"
                    id="filtroCliente"
                    className="form-control"
                    placeholder="Filtrar por cliente"
                    value={filtroCliente}
                    onChange={(e) => setFiltroCliente(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="filtroCondicionPago" className="form-label">Condición de Pago</label>
                  <input
                    type="text"
                    id="filtroCondicionPago"
                    className="form-control"
                    placeholder="Filtrar por condición"
                    value={filtroCondicionPago}
                    onChange={(e) => setFiltroCondicionPago(e.target.value)}
                  />
                </div>
                <div className="col-12 text-end">
                  <button 
                    type="button" 
                    className="btn btn-outline-secondary"
                    onClick={limpiarFiltros}
                  >
                    Limpiar Filtros
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          {error && (
            <div className="alert alert-danger d-flex justify-content-between align-items-center">
              <span>Error: {error}</span>
              <button onClick={consultarApi} className="btn btn-sm btn-danger">
                Reintentar
              </button>
            </div>
          )}
          
          <div className="table-responsive">
            <h2 className="mb-3">Resultados de Liquidaciones</h2>
            {cargando ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
                <p className="mt-2">Cargando datos...</p>
              </div>
            ) : respuestaApi.length > 0 ? (
              <table className="table table-striped table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Distribuidora</th>
                    <th>Ruta</th>
                    <th>No. Ref.</th>
                    <th>Documento</th> 
                    <th>Codigo Cliente</th> 
                    <th>Nombre de Cliente</th>
                    <th>Fecha Doc.</th>
                    <th>Total</th>
                    <th>Liquidacion de documento</th>                   
                    <th>Condición Pago</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {respuestaApi.map((item, index) => (
                    <tr key={index}>
                      <td>{item.Distribuidora}</td>
                      <td>{item.Ruta}</td>
                      <td>{item.Num_Ref}</td> 
                      <td>{item.Num_Documento}</td>
                      <td>{item.Codigo_Cliente}</td>
                      <td>{item.Nombre_CLiente}</td>
                      <td>{formatearFecha(item.Fecha_Doc)}</td>
                      <td className="text-end">Q {item.Total_Documento?.toFixed(2)}</td> 
                      <td>{item['Liquidacion Documento']}</td>
                      <td>{item.Condicion_Pago}</td>
                      <td>
                        <span className={`badge ${item.Pagado === 'No Pagada' ? 'bg-danger' : 'bg-success'}`}>
                          {item.Pagado}
                        </span> 
                        <button 
                            className="btn btn-sm btn-success ms-2"
                            onClick={() => handleCheckClick(item)}
                            title="Marcar como correcto" 
                            style={{width: "30px", height: "30px"}}
                        >
                           <i className="fas fa-check fa-sm me-1"></i>
                        </button>
                        
                        {/* Botón de Comentario */}
                        <button 
                            className="btn btn-sm btn-warning ms-2"
                            onClick={() => handleComentarioClick(item)}
                            title="Agregar comentario"
                            style={{width: "30px",height: "30px" }}
                        >
                           <i className="fas fa-comments fa-sm me-1"></i>
                        </button>
                      </td>
                      <td>
                        <button 
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleSeguimientoClick(item)}
                          disabled={cargandoSeguimiento}
                        >
                          {cargandoSeguimiento ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          ) : (
                            'Seguimiento'
                          )}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="alert alert-info">
                No se encontraron liquidaciones para la fecha seleccionada.
              </div>
            )}
          </div>
        </div>
      </div> 
  {showComentarioModal && (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
            <h5 className="modal-title">Agregar Comentario</h5>
            <button type="button" className="btn-close" onClick={() => {
                setShowComentarioModal(false);
                setComentario('');
            }}></button>
            </div>
            <div className="modal-body">
            <div className="mb-3">
                <label className="form-label">Comentario:</label>
                <textarea
                className="form-control"
                rows="3"
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
                placeholder="Ingrese su comentario"
                required
                />
            </div>
            </div>
            <div className="modal-footer">
            <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={() => {
                setShowComentarioModal(false);
                setComentario('');
                }}
            >
                Cancelar
            </button>
            <button 
                type="button" 
                className="btn btn-primary" 
                onClick={confirmarComentario}
            >
                Guardar Comentario
            </button>
            </div>
        </div>
        </div>
    </div>
    )}
    </div>
  );
};

export default ConsultaLiquidaciones;